import { IRapportInfo } from '../../../../../Types/RapportInfoType';
import { rapportInfos } from '../RapportInfo';

const BORapportMeny: IRapportInfo[] = [rapportInfos.BOForsamlingsstatistik];

export default BORapportMeny;
